{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Facturación",
    "login": "Login",
    "support": "Support",
    "support-tickets": "Tickets & notes",
    "preferences": "Account preferences",
    "payments": "Planes / Pagos",
    "settings": "Configuración del sistema",
    "pricing-plans": "Planes Empresarial",
    "payment-methods": "Medios Pagos",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Usuarios",
    "projects": "Empresas",
    "sales-funnel": "Embudo de Ventas",
    "empleados-empresarial": "Lista Empleados Empresarial",
    "convenios": "Convenios",
    "funerarias": "Funerarias"
  },
  "embudo": {
    "pageTitle": "Embudo de Ventas",
    "bannerTitle": "Embudo de Ventas — Proceso Plan Empresarial",
    "bannerSubtitle": "7 etapas incluyendo Cerrado Ganado y Cerrado Perdido",
    "emptyColumn": "Sin empresas",
    "newCompany": "Nueva Empresa",
    "toolbarGestion": "Gestión empresa",
    "gestionPickerPlaceholder": "Elige empresa…",
    "pickCompanyFirst": "Elige una empresa en la lista para abrir su gestión.",
    "summary": {
      "title": "Seguimiento",
      "empty": "Sin datos de seguimiento — usa Gestión empresa",
      "estatus": "Estatus",
      "gestion": "Gestión",
      "ciudad": "Ciudad",
      "ultimaActividad": "Última actividad",
      "proximo": "Próximo paso"
    },
    "hint": "Arrastra una empresa a otra columna para cambiar de etapa.",
    "saveError": "No se pudo guardar la etapa. Intenta de nuevo.",
    "stages": {
      "base_datos": "BASE DE DATOS",
      "activar": "ACTIVAR",
      "estrechar": "ESTRECHAR",
      "pronostico": "PRONÓSTICO",
      "post_venta": "POST VENTA",
      "cerrado_ganado": "CERRADO GANADO",
      "cerrado_perdido": "CERRADO PERDIDO"
    },
    "gestion": {
      "title": "Gestión Empresa",
      "selectPlaceholder": "— Seleccionar —",
      "sectionGeneral": "Datos generales",
      "sectionContacto": "Contacto",
      "sectionEmbudo": "Embudo y actividades",
      "sectionCrm": "Campos CRM (Salesforce)",
      "empresa": "Empresa",
      "tipo": "Tipo",
      "tipoGestion": "Tipo de gestión",
      "ciudad": "Ciudad",
      "ciudadPh": "Ej: Ciudad Juárez",
      "estatus": "Estatus",
      "nombreContacto": "Nombre contacto",
      "correo": "Correo",
      "telefono": "Teléfono",
      "telefonoPh": "10 digits",
      "telefonoRequired": "Phone is required",
      "telefono10Digits": "Phone must be exactly 10 digits",
      "telefonoSaveError": "Enter a 10-digit phone number before saving",
      "fechaContacto": "Fecha contacto",
      "etapaEmbudo": "Etapa del embudo",
      "actividades": "Actividades",
      "agregar": "+ Agregar",
      "descripcionPh": "Descripción…",
      "proximoPaso": "Próximo paso",
      "numEmpleados": "Núm. empleados",
      "motivoPerdido": "Motivo si perdido",
      "motivoPerdidoPh": "Razón de descarte",
      "origenLead": "Origen del lead",
      "montoEstimado": "Monto estimado ($)",
      "fechaCierreEstimada": "Fecha cierre estimada",
      "probabilidad": "Probabilidad (%)",
      "asesorId": "ID asesor",
      "correoAsesor": "Correo asesor",
      "siguientePasoCrm": "Siguiente paso (CRM)",
      "siguientePasoCrmPh": "Acción concreta a tomar",
      "notas": "Notas",
      "cancelar": "Cancelar",
      "guardar": "Guardar",
      "saveOk": "Seguimiento guardado",
      "saveError": "No se pudo guardar"
    },
    "gestionEmpresa": "Gestión empresa"
  },
  "empleadosEmp": {
    "title": "Lista Empleados Empresarial",
    "searchPh": "Buscar por nombre, RFC, correo…",
    "downloadTemplate": "Plantilla CSV",
    "uploadCsv": "Subir CSV",
    "add": "Agregar registro",
    "editTitle": "Editar empleado",
    "newTitle": "Nuevo empleado",
    "save": "Guardar",
    "create": "Crear",
    "savedUpdate": "Registro actualizado",
    "savedCreate": "Registro creado",
    "errorLoad": "No se pudo cargar la lista",
    "errorSave": "No se pudo guardar",
    "errorDelete": "No se pudo eliminar",
    "deleteTitle": "Eliminar registro",
    "deleteMsg": "¿Eliminar el registro de {nombre}?",
    "deleteOk": "Eliminar",
    "deleted": "Registro eliminado",
    "csvEmpty": "El CSV no tiene filas de datos",
    "csvOk": "Se importaron {n} registros",
    "csvError": "Error al importar CSV",
    "unsavedClose": "Hay cambios sin guardar. ¿Cerrar de todos modos?"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Configuración del sistema",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "settingsPage": {
    "title": "Configuración del sistema",
    "theme": "Tema",
    "themeDark": "Oscuro",
    "themeLight": "Claro",
    "themeMausoleo": "Mausoleo",
    "generalPreferences": "Preferencias generales",
    "language": "Idioma",
    "notificationsAlertTitle": "Tus preferencias de notificación están agrupadas y simplificadas",
    "notificationsAlertText": "Tus opciones anteriores no se han modificado.",
    "notificationsSectionTitle": "Notificaciones que recibes"
  },
  "aboutVuesticAdmin": "About CRM Empresarial",
  "aboutCrmManualPending": "User manual upload pending.",
  "supportAndConsulting": "Contactanos",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  }
}
